// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-light: #eee;
  --border-radius: 15px;
  --primary: #442244;
  --primary-light: #663366;
  --debug-console-width: 0;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  /*padding-left: var(--debug-console-width);*/
  background-color: #222;
  font-family: monospace;
  font-size: 20px;
}

#container {
  /* width: calc(100svw - (var(--debug-console-width) + 10px));*/
  width: 100svw;
  height: 98svh;
  max-width: 1920px;
  max-height: 1080px;
  margin: 0 auto;
  margin-top: 1svh;
  position: relative;
  filter: drop-shadow(0 0 40px #333);
}
#container canvas {
  filter: drop-shadow(0 0 40px #333);
}

#overlay.show {
  display: block;
}
#overlay {
  display: none;
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #333333dd;
  text-align: center;
  color: var(--font-light);
  overflow: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
/* Hide scrollbar for Chrome, Safari and Opera */
#overlay::-webkit-scrollbar {
  display: none;
}
#debug {
  position: absolute;
  left: 0;
  top: 0;
}

.hidden {
  display: none;
}

.column-wrapper {
  container-type: inline-size;
}
.columns {
  display: grid;
  gap: 2rem;
}
@container (width > calc(200px * 3)) {
  .columns {
    grid-template-columns: repeat(var(--column-count, 3), 1fr);
  }
}

button {
  outline: none;
  border: 2px solid #ffffffcc;
  filter: drop-shadow(0 0 40px #333);
  padding: 15px 10px;
  border-radius: var(--border-radius);
  color: var(--font-light);
  background-color: var(--primary);
  font-size: 1.5rem;
  font-weight: bold;
  transition: all 200ms ease-in-out;
}
button:hover {
  cursor: pointer;
  background-color: var(--primary-light);
}

img {
  filter: drop-shadow(0 0 40px #333);
}

h1 {
  color: #AA4444;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8DAA8D;EAC9D,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;AACA,gDAAgD;AAChD;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB;EACxB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[":root {\n  --font-light: #eee;\n  --border-radius: 15px;\n  --primary: #442244;\n  --primary-light: #663366;\n  --debug-console-width: 0;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  /*padding-left: var(--debug-console-width);*/\n  background-color: #222;\n  font-family: monospace;\n  font-size: 20px;\n}\n\n#container {\n  /* width: calc(100svw - (var(--debug-console-width) + 10px));*/\n  width: 100svw;\n  height: 98svh;\n  max-width: 1920px;\n  max-height: 1080px;\n  margin: 0 auto;\n  margin-top: 1svh;\n  position: relative;\n  filter: drop-shadow(0 0 40px #333);\n}\n#container canvas {\n  filter: drop-shadow(0 0 40px #333);\n}\n\n#overlay.show {\n  display: block;\n}\n#overlay {\n  display: none;\n  z-index: 2;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #333333dd;\n  text-align: center;\n  color: var(--font-light);\n  overflow: hidden;\n  overflow-y: scroll;\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n/* Hide scrollbar for Chrome, Safari and Opera */\n#overlay::-webkit-scrollbar {\n  display: none;\n}\n#debug {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.hidden {\n  display: none;\n}\n\n.column-wrapper {\n  container-type: inline-size;\n}\n.columns {\n  display: grid;\n  gap: 2rem;\n}\n@container (width > calc(200px * 3)) {\n  .columns {\n    grid-template-columns: repeat(var(--column-count, 3), 1fr);\n  }\n}\n\nbutton {\n  outline: none;\n  border: 2px solid #ffffffcc;\n  filter: drop-shadow(0 0 40px #333);\n  padding: 15px 10px;\n  border-radius: var(--border-radius);\n  color: var(--font-light);\n  background-color: var(--primary);\n  font-size: 1.5rem;\n  font-weight: bold;\n  transition: all 200ms ease-in-out;\n}\nbutton:hover {\n  cursor: pointer;\n  background-color: var(--primary-light);\n}\n\nimg {\n  filter: drop-shadow(0 0 40px #333);\n}\n\nh1 {\n  color: #AA4444;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
